export default __webpack_public_path__ + "static/media/Schunk.4e66fe93.png";